export const journeyStrings = {
  "journey.pricing.explanationCalculated": { en: "Calculated from", he: "מחושב לפי" },
  "journey.pricing.explanationPreliminaryQuantity": {
    en: "Preliminary estimate for {quantity} {unit}. Pricing will update as you continue.",
    he: "הערכת מחיר ראשונית ל־{quantity} {unit}. המחיר יתעדכן בהמשך המסע.",
  },
  "journey.pricing.explanationPreliminary": {
    en: "Preliminary estimate. Pricing will update as you continue.",
    he: "הערכת מחיר ראשונית. המחיר יתעדכן בהמשך המסע.",
  },
  "journey.pricing.explanationProject": {
    en: "Estimate based on the project details selected.",
    he: "הערכת מחיר לפי פרטי הפרויקט שנבחרו.",
  },
  "journey.pricing.explanationPending": {
    en: "The estimate will update once the relevant choices are completed.",
    he: "הערכת המחיר תתעדכן לאחר השלמת הבחירות הרלוונטיות.",
  },
  "journey.pricing.explanationReview": {
    en: "Pricing will be confirmed after the project details are reviewed.",
    he: "הערכת המחיר תאושר לאחר בדיקת פרטי הפרויקט.",
  },
  "journey.pricing.unitSquareMeter": { en: "m²", he: "מ״ר" },
  "journey.pricing.unitMeter": { en: "m", he: "מטר" },
  "journey.pricing.unitCount": { en: "units", he: "יחידות" },
  "journey.pricing.unitCountSingular": { en: "unit", he: "יחידה" },
  "journey.pricing.pendingLabel": { en: "Pricing pending", he: "ממתינים לפרטי התמחור" },
  "journey.pricing.pending": {
    en: "Pricing pending project details",
    he: "המחיר ייקבע לאחר השלמת פרטי הפרויקט",
  },
  "journey.pricing.rate": { en: "Rate:", he: "תעריף:" },
  "journey.pricing.sourceRate": {
    en: "Source rate; project price depends on quantity and applicable adjustments",
    he: "תעריף מקור; מחיר הפרויקט תלוי בכמות ובהתאמות החלות",
  },
  "journey.pricing.perNamedUnit": { en: "per {unit}", he: "ל{unit}" },
  "journey.pricing.showDetails": { en: "Show pricing explanation", he: "הצגת הסבר לתמחור" },
  "journey.pricing.hideDetails": { en: "Hide pricing explanation", he: "הסתרת הסבר לתמחור" },
  "journey.pricing.base": { en: "Base:", he: "מחיר בסיס:" },
  "journey.pricing.adds": { en: "Adds", he: "תוספת של" },
  "journey.pricing.reduces": { en: "Reduces this offering subtotal by", he: "הפחתה מסכום הביניים של" },
  "journey.pricing.adjusts": { en: "Adjusts this offering subtotal by", he: "התאמה לסכום הביניים של" },
  "journey.pricing.perUnit": { en: "per unit", he: "ליחידה" },
  "journey.pricing.multiplier": { en: "Multiplies this offering subtotal by", he: "הכפלת סכום הביניים ב־" },
  "journey.pricing.always": { en: "Whenever this offering is selected.", he: "בכל פעם שמוצר או שירות זה נבחר." },
  "journey.pricing.answered": { en: "When “{question}” has an answer.", he: "כאשר יש תשובה לשאלה ״{question}״." },
  "journey.pricing.any": { en: "Once when any of “{answers}” is selected for “{question}”.", he: "פעם אחת כאשר נבחרת אחת מהתשובות ״{answers}״ לשאלה ״{question}״." },
  "journey.pricing.exact": { en: "Only when “{question}” equals: {answers}.", he: "רק כאשר הערך של ״{question}״ שווה ל־{answers}." },
  "journey.pricing.quantity": { en: "Rate × the full answer to “{question}”.", he: "התעריף כפול הערך המלא של התשובה לשאלה ״{question}״." },
  "journey.pricing.currentQuantity": { en: "Current quantity: {quantity}.", he: "הכמות הנוכחית: {quantity}." },
  "journey.pricing.signed": { en: "The editor keeps the signed amounts: negative values subtract.", he: "בעריכה נשמר סימן הסכום: ערכים שליליים מפחיתים מהמחיר." },
  "journey.pricing.rangeUsed": { en: "Both endpoints above are used in the estimate calculation.", he: "שני קצות הטווח משמשים בחישוב האומדן." },
  "journey.pricing.detailsHint": { en: "Review the full rule and edit its numbers in How pricing works.", he: "אפשר לבדוק את הכלל המלא ולערוך את המספרים באזור ״איך המחיר מחושב״." },
  "journey.pricing.precisionHint": { en: "Use a Journey instruction to change this multiplier while preserving its precision.", he: "לשינוי מכפיל זה תוך שמירה על הדיוק שלו, השתמשו בהנחיה למסע." },
  "journey.pricing.applied": { en: "Applies to the current estimate", he: "חל על האומדן הנוכחי" },
  "journey.pricing.inactive": { en: "Not applied with the current answers", he: "אינו חל עם התשובות הנוכחיות" },
  "journey.pricing.selectedAlways": { en: "Included automatically in this journey.", he: "כלול אוטומטית במסע זה." },
  "journey.pricing.notSelected": { en: "No selection in this journey includes this offering.", he: "אין במסע זה בחירה שכוללת מוצר או שירות זה." },
  "journey.pricing.selectedWhen": { en: "Selected by “{answers}” in “{question}”.", he: "נבחר באמצעות ״{answers}״ בשאלה ״{question}״." },
  "journey.pricing.fallback": { en: "Default when “{question}” has no answer that selects another offering, including when that question is skipped.", he: "ברירת המחדל כאשר אין בשאלה ״{question}״ תשובה שבוחרת מוצר או שירות אחר, כולל כאשר מדלגים על השאלה." },
  "journey.pricing.amount": { en: "Amount", he: "סכום" },
  "journey.pricing.low": { en: "Low amount", he: "סכום תחתון" },
  "journey.pricing.high": { en: "High amount", he: "סכום עליון" },
  "journey.pricing.percentage": { en: "Percentage adjustment", he: "התאמה באחוזים" },
  "journey.pricing.invalidModel": { en: "This change does not produce a valid pricing model.", he: "השינוי אינו יוצר מודל תמחור תקין." },
  "journey.pricing.invalidPercentage": { en: "Enter a percentage greater than -100%.", he: "יש להזין אחוז גדול מ־‎-100%." },
  "journey.pricing.invalidRange": { en: "Enter finite amounts with high at least low; base prices must be nonnegative.", he: "יש להזין סכומים סופיים, כאשר הסכום העליון אינו נמוך מהתחתון. מחירי הבסיס חייבים להיות לא שליליים." },
  "journey.history": { en: "Changes applied", he: "שינויים שהוחלו" },
  "journey.discard.action": { en: "Discard unpublished changes", he: "ביטול השינויים שלא פורסמו" },
  "journey.discard.title": {
    en: "Discard all unpublished changes?",
    he: "לבטל את כל השינויים שלא פורסמו?",
  },
  "journey.discard.body": {
    en: "All changes made since the last publication will be removed. Your currently published Journey will remain unchanged.",
    he: "כל השינויים שביצעת במסע הלקוח מאז הפרסום האחרון יימחקו. הגרסה הפעילה תישאר ללא שינוי.",
  },
  "journey.discard.cancel": { en: "Keep editing", he: "חזרה לעריכה" },
  "journey.discard.confirm": { en: "Discard changes", he: "ביטול השינויים" },
  "journey.discard.busy": {
    en: "Loading the published Journey?",
    he: "טוענים את מסע הלקוח שפורסם…",
  },
  "journey.discard.failure": {
    en: "Could not discard changes. Your draft is preserved. Please try again.",
    he: "לא הצלחנו לבטל את השינויים. הטיוטה נשמרה. נסו שוב.",
  },
  "journey.discard.conflict": {
    en: "This draft changed or is busy in another tab. Reload to review the saved work before discarding.",
    he: "הטיוטה השתנתה או נמצאת בשימוש בלשונית אחרת. טענו מחדש כדי לבדוק את העבודה השמורה לפני ביטול השינויים.",
  },
  "journey.discard.malformed": {
    en: "The saved draft cannot be read. You can discard it below to return to the published Journey.",
    he: "לא ניתן לקרוא את הטיוטה השמורה. אפשר לבטל את השינויים למטה ולחזור למסע הלקוח שפורסם.",
  },
  "journey.discard.unsupported": {
    en: "Safe discard requires browser tab coordination. Open this workspace in an up-to-date browser over HTTPS or localhost.",
    he: "ביטול בטוח דורש תיאום בין לשוניות. פתחו את סביבת העבודה בדפדפן מעודכן דרך HTTPS או localhost.",
  },
  "journey.deploy.title": { en: "Deploy journey", he: "פרסום מסע הלקוח" },
  "journey.deploy.body": {
    en: "Publish the completed Draft as the new live customer journey.",
    he: "פרסמו את הטיוטה המוכנה כמסע הלקוח הפעיל החדש.",
  },
  "journey.deploy.action": { en: "Deploy version {version}", he: "פרסום גרסה {version}" },
  "journey.deploy.permission": {
    en: "Management access is required to deploy this journey.",
    he: "נדרשת הרשאת ניהול כדי לפרסם את מסע הלקוח.",
  },
  "journey.deploy.notReady": {
    en: "Finish your changes with Update journey before deploying.",
    he: "השלימו את השינויים באמצעות עדכון מסע הלקוח לפני הפרסום.",
  },
  "journey.deploy.notConnected": {
    en: "Deployment is not available yet. You can review the confirmation; your Draft stays saved.",
    he: "הפרסום עדיין אינו זמין. אפשר לעיין באישור הפרסום; הטיוטה נשארת שמורה.",
  },
  "journey.deploy.confirm": { en: "Deploy this version?", he: "לפרסם את הגרסה הזו?" },
  "journey.deploy.confirmBody": {
    en: "This Draft will become the live journey for new customer sessions.",
    he: "טיוטה זו תהפוך למסע הפעיל עבור ביקורי לקוחות חדשים.",
  },
  "journey.deploy.progress": { en: "Deploying your journey", he: "מפרסמים את מסע הלקוח" },
  "journey.deploy.progressBody": {
    en: "Keep this window open while deployment completes.",
    he: "השאירו חלון זה פתוח עד להשלמת הפרסום.",
  },
  "journey.deploy.starting": { en: "Starting deployment…", he: "מתחילים בפרסום…" },
  "journey.deploy.preparing": { en: "Preparing the version", he: "הכנת הגרסה" },
  "journey.deploy.saving": {
    en: "Saving the version and its history",
    he: "שמירת הגרסה וההיסטוריה שלה",
  },
  "journey.deploy.publishing": { en: "Publishing the live journey", he: "פרסום מסע הלקוח הפעיל" },
  "journey.deploy.finalizing": { en: "Finalizing deployment", he: "השלמת הפרסום" },
  "journey.deploy.failed": { en: "Journey not deployed", he: "מסע הלקוח לא פורסם" },
  "journey.deploy.unavailable": {
    en: "Deployment is not available yet. Your Draft is preserved and your live journey is unchanged.",
    he: "הפרסום עדיין אינו זמין. הטיוטה נשמרה ומסע הלקוח הפעיל לא השתנה.",
  },
  "journey.deploy.failure": {
    en: "We couldn’t confirm deployment. Your Draft is preserved. Please try again.",
    he: "לא הצלחנו לאשר את הפרסום. הטיוטה נשמרה. נסו שוב.",
  },
  "journey.deploy.retry": { en: "Retry deployment", he: "ניסיון נוסף לפרסום" },
  "journey.deploy.success": { en: "Version {version} is now live", he: "גרסה {version} פעילה כעת" },
  "journey.deploy.successBody": {
    en: "New customer sessions will use this journey.",
    he: "ביקורי לקוחות חדשים ישתמשו במסע זה.",
  },
  "journey.progressElapsed": { en: "Elapsed", he: "זמן שחלף" },
  "journey.progressTitle": { en: "Updating your journey", he: "מעדכנים את המסע שלכם" },
  "journey.progressBody": {
    en: "Qotta is applying your changes and rebuilding the customer journey. This may take a little while.",
    he: "Qotta מחילה את השינויים שלכם ובונה מחדש את מסע הלקוח. זה עשוי לקחת מעט זמן.",
  },
  "journey.preview": { en: "Preview", he: "תצוגה מקדימה" },
  "journey.editMode": { en: "Edit", he: "עריכה" },
  "journey.mode": { en: "Journey mode", he: "מצב המסע" },
  "journey.reviewPreview": { en: "Review journey", he: "חזרה למסע הלקוח" },
  "journey.previewEnd": {
    en: "End of preview. No contact request or lead is created here.",
    he: "סוף התצוגה המקדימה. לא נוצרים כאן ליד או בקשת קשר.",
  },
  "journey.ephemeral": {
    en: "Local preview · Changes are not saved",
    he: "תצוגה מקומית · השינויים אינם נשמרים",
  },
  "journey.managementRequired": {
    en: "Manage this business to apply your instructions with Update journey.",
    he: "נדרשת הרשאת ניהול לעסק כדי להחיל את ההנחיות באמצעות עדכון מסע הלקוח.",
  },
  "journey.estimateValidity": {
    en: "Estimate calculated from the journey shown here",
    he: "ההערכה מחושבת לפי מסע הלקוח המוצג כאן",
  },
  "journey.contactPreview": {
    en: "This is a journey preview. No contact request will be sent.",
    he: "זוהי תצוגה מקדימה של מסע הלקוח. לא תישלח בקשת קשר.",
  },
  "nav.journey": { en: "Journey", he: "מסע לקוח" },
  "journey.subtitle": {
    en: "Shape the next version of your customer journey.",
    he: "שפרו את הגרסה הבאה של מסע הלקוח שלכם.",
  },
  "journey.improve": { en: "Improve this journey", he: "שיפור מסע הלקוח" },
  "journey.hint": {
    en: "Edit the journey directly or describe what you want to change.",
    he: "ערכו את מסע הלקוח ישירות או תארו מה תרצו לשנות.",
  },
  "journey.empty": {
    en: "Your next improvement starts here. Add an instruction or edit a question, answer, or price in the journey.",
    he: "השיפור הבא מתחיל כאן. הוסיפו הנחיה או ערכו שאלה, תשובה או מחיר במסע הלקוח.",
  },
  "journey.live": { en: "Live version", he: "גרסה פעילה" },
  "journey.currentLive": { en: "Current live version", he: "הגרסה הפעילה כעת" },
  "journey.next": { en: "Next version", he: "הגרסה הבאה" },
  "journey.notLive": { en: "Not live", he: "טרם פורסמה" },
  "journey.ready": { en: "Ready to deploy", he: "מוכנה לפרסום" },
  "journey.saved": { en: "Draft saved in this browser", he: "הטיוטה נשמרה בדפדפן זה" },
  "journey.pending": { en: "Pending instructions", he: "הנחיות ממתינות" },
  "journey.automatic": { en: "Journey edit", he: "עריכה במסע הלקוח" },
  "journey.owner": { en: "You", he: "אתם" },
  "journey.instruction": { en: "Instruction", he: "הנחיה" },
  "journey.placeholder": { en: "Describe a change to your journey…", he: "תארו שינוי במסע הלקוח…" },
  "journey.add": { en: "Add instruction", he: "הוספת הנחיה" },
  "journey.edit": { en: "Edit instruction", he: "עריכת הנחיה" },
  "journey.delete": { en: "Delete instruction", he: "מחיקת הנחיה" },
  "journey.revert": { en: "Revert journey edit", he: "ביטול העריכה במסע הלקוח" },
  "journey.attach": { en: "Attach files · Coming soon", he: "צירוף קבצים · בקרוב" },
  "journey.removeAttachment": { en: "Remove attachment", he: "הסרת קובץ מצורף" },
  "journey.update": { en: "Update journey", he: "עדכון מסע הלקוח" },
  "journey.updating": { en: "Updating your journey…", he: "מסע הלקוח מתעדכן…" },
  "journey.applied": {
    en: "Your instructions have been applied. Review the updated journey or add another improvement.",
    he: "ההנחיות יושמו. בדקו את מסע הלקוח המעודכן או הוסיפו שיפור נוסף.",
  },
  "journey.deployLater": {
    en: "Your live journey stays unchanged. Deployment will be available in a later release.",
    he: "מסע הלקוח הפעיל נשאר ללא שינוי. פרסום יהיה זמין בגרסה עתידית.",
  },
  "journey.clarification": { en: "A little more detail", he: "נדרשים עוד כמה פרטים" },
  "journey.answer": { en: "Your answer", he: "התשובה שלכם" },
  "journey.retry": { en: "Retry journey generation", he: "ניסיון נוסף ליצירת מסע הלקוח" },
  "journey.staged": {
    en: "Your instructions are understood. Journey generation needs another attempt; your previous draft is safe.",
    he: "ההנחיות עובדו. נדרש ניסיון נוסף ליצירת מסע הלקוח; הטיוטה הקודמת נשמרה.",
  },
  "journey.error": {
    en: "We couldn’t update the journey. Your saved work is safe. Please try again.",
    he: "לא הצלחנו לעדכן את מסע הלקוח. העבודה שנשמרה בטוחה. נסו שוב.",
  },
  "journey.missingVersion": {
    en: "The published Discovery model is missing required metadata: versionNumber.",
    he: "במודל Discovery שפורסם חסר מידע נדרש: versionNumber.",
  },
  "journey.loadError": {
    en: "We couldn’t open this journey. Please reload to try again.",
    he: "לא הצלחנו לפתוח את מסע הלקוח. רעננו ונסו שוב.",
  },
  "journey.storageError": {
    en: "This change could not be saved in your browser. Free some browser storage and reload before continuing.",
    he: "לא ניתן לשמור את השינוי בדפדפן. פנו מקום באחסון הדפדפן ורעננו לפני שתמשיכו.",
  },
  "journey.conflict": {
    en: "This draft or the live version changed elsewhere. Reload to review the saved workspace before continuing.",
    he: "הטיוטה או הגרסה הפעילה השתנו במקום אחר. רעננו כדי לבדוק את סביבת העבודה השמורה לפני שתמשיכו.",
  },
  "journey.stale": {
    en: "This draft is based on an older live version. Your work is preserved; it needs reconciliation before updating.",
    he: "הטיוטה מבוססת על גרסה פעילה קודמת. העבודה נשמרה ונדרשת התאמה לפני עדכון.",
  },
  "journey.legacy": {
    en: "This business needs a one-time data upgrade before journey improvements can be generated. Your instructions can still be saved.",
    he: "נדרש שדרוג חד־פעמי לנתוני העסק לפני יצירת שיפורים במסע הלקוח. ניתן להמשיך לשמור הנחיות.",
  },
  "journey.readOnly": {
    en: "Try editing the journey and adding instructions. These preview changes are not saved; management access is required to apply them.",
    he: "אפשר להתנסות בעריכת מסע הלקוח ובהוספת הנחיות. השינויים בתצוגה זו אינם נשמרים; נדרשת הרשאת ניהול כדי להחיל אותם.",
  },
  "journey.limit": {
    en: "Use up to 100 instructions and 100 KB of text per update.",
    he: "ניתן לעדכן עד 100 הנחיות ו־100 ק״ב טקסט בכל עדכון.",
  },
  "journey.loading": { en: "Loading journey…", he: "מסע הלקוח נטען…" },
};
